import { has, get } from 'lodash';
import { down } from 'styled-breakpoints';
import { css } from 'styled-components';

const getFontToken = (componentKey, key, prop, propValue = 'default', appearance = 'default') => ({ theme }) => {
    const tokenPaths = [
        `${componentKey}.appearance.${appearance}.${prop}.${propValue}.${key}`,
        ...propValue !== 'default' ? [`${componentKey}.appearance.${appearance}.${prop}.default.${key}`] : [],
        ...appearance !== 'default' ? [`${componentKey}.appearance.default.${prop}.${propValue}.${key}`] : [],
        ...appearance !== 'default' && propValue !== 'default' ?
            [`${componentKey}.appearance.default.${prop}.default.${key}`] : [],
    ];
    for (const tokenPath of tokenPaths) {
        if (has(theme.fontStyles, tokenPath)) {
            return get(theme.fontStyles, tokenPath);
        }
    }
    return undefined;
};
const getFontTokenStyle = (style, size, variant, appearance) => css `
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: auto;
  font-smoothing: antialiased;

  color: ${getFontToken(style, 'color', 'variant', variant, appearance)};
  font-family: ${getFontToken(style, 'fontFamily', 'variant', variant, appearance)};
  text-decoration: ${getFontToken(style, 'textDecoration', 'variant', variant, appearance)};
  font-size: ${getFontToken(style, 'fontSize', 'size', size, appearance)};
  letter-spacing: ${getFontToken(style, 'letterSpacing', 'size', size, appearance)};
  font-style: ${getFontToken(style, 'fontStyle', 'variant', variant, appearance)};
  font-weight: ${getFontToken(style, 'fontWeight', 'variant', variant, appearance)};
  line-height: ${getFontToken(style, 'lineHeight', 'size', size, appearance)};

  ${down('xs')} {
    font-size: ${getFontToken(style, 'mobileFontSize', 'size', size, appearance)};
    line-height: ${getFontToken(style, 'mobileLineHeight', 'size', size, appearance)};
  }

  &:hover, .hover {
    color: ${getFontToken(style, 'colorHover', 'variant', variant, appearance)};
    text-decoration: ${getFontToken(style, 'textDecorationHover', 'variant', variant, appearance)};
  }
  .active {
    color: ${getFontToken(style, 'colorActive', 'variant', variant, appearance)};
    text-decoration: ${getFontToken(style, 'textDecorationActive', 'variant', variant, appearance)};
  }
`;

export { getFontToken, getFontTokenStyle };
//# sourceMappingURL=getFontTokenStyle.js.map
